/** Same-origin Snag Builder API base (proxied to AliFullStack gateway). */
export function resolveAliFullStackBase() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === 'snagcart.io' ||
      host.endsWith('.snagcart.io')
    ) {
      return '/alifullstack-api';
    }
  }
  const env = (process.env.REACT_APP_ALIFULLSTACK_URL || '').replace(/\/$/, '');
  if (env && !/^https?:\/\//i.test(env)) {
    return env.startsWith('/') ? env : `/${env}`;
  }
  if (env && typeof window !== 'undefined' && env === window.location.origin) {
    return `${env}/alifullstack-api`;
  }
  return '/alifullstack-api';
}
